// extracted by mini-css-extract-plugin
export default {"formWrapper":"FormFieldTranslationsNew_formWrapper__aI-TB"};